import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { usersStatsQueryKeys } from '@/domains/user/api/users-stats';

export const useUserDailyCaseResolvingStatsQuery = () => {
  const initialDate = useMemo(() => +dayjs().startOf('day').toDate(), []);
  const { data = [], isLoading } = useQuery(
    // @ts-ignore
    usersStatsQueryKeys.casesResolvedStats({ fromDate: initialDate }),
  );

  return {
    data,
    isLoading,
  };
};
